module.exports = __webpack_public_path__ + "img/ic_logo_free@2x.10cbe414.png";